// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases.addvariantdetail', {
        url:'/addvariantdetail',
        views: {
            'supportView@support': {
            templateUrl: 'main/support/supportcases/addvariantdetail/addvariantdetail.tpl.html',
            controller: 'SupportCaseAddVariantDetailController as vm'
        }},
        resolve: {
            variants: variantsResolver
        }
    });
}

// @ngInject
function variantsResolver(VariantsApiService) {
    return VariantsApiService.getVariants();
}

// @ngInject
function SupportCaseAddVariantDetailController($state, $scope, SupportApiService, variants, loadSpinnerService, ToasterService, confirmationDialogService, $translate) {
    var vm = this;

    //Properties
    vm.statisticName = 'UNKNOWN';
    vm.variantsToAdd = 1;
    vm.selectedVariant;
    vm.variants = variants;
    vm.fulltextInput = "";

    vm.autoSortOrder = true;
    vm.useListOfItems = false;
    
    vm.newVariantDetails = [];

    vm.variantDetailTemplate = {
        variantDetailName : '', 
        sortOrder : 0,
        overrideAutoSort : false
    }

    updateListOfVariants();

    //Methods
    vm.saveChange = saveChange;
    vm.cancelEditing = cancelEditing;
    vm.isAllowedToSave = isAllowedToSave;
    vm.updateListOfVariants = updateListOfVariants;
    vm.doAutoSortOrder = doAutoSortOrder;
    vm.convertToLines = convertToLines;

    activate();

    function activate() {
        console.log(vm.variants);
        $scope.$watch( vm.variantsToAdd , function() {
            if(vm.variantsToAdd < 1)
                vm.variantsToAdd = 1;
            else if(vm.variantsToAdd > 50)
                vm.variantsToAdd = 50;
        });
        //$scope.$watch(function() { return $state.params.variantId; }, function(newValue, oldValue) {
        //    vm.selectedVariantId = parseInt($state.params.variantId, 10);
        //});
    }

    function convertToLines() {
        var splittedValues = vm.fulltextInput.split('\n');

        var newVariantDetails = [];

        _.forEach(splittedValues, function(value){
            value = value.trim();
            var newDetail = angular.copy(vm.variantDetailTemplate);
            newDetail.variantDetailName = value;
            newVariantDetails.push(newDetail);
        });

        vm.newVariantDetails = newVariantDetails;
        vm.variantsToAdd = vm.newVariantDetails.length;
        updateListOfVariants();

        vm.fulltextInput = "";
        vm.useListOfItems = false;
    }

    function saveChange() {
        confirmationDialogService.showDialog('<div>' + $translate.instant("support.confirmCreateData") + '</div>').then(function (result) {
            if (result === true) {
                loadSpinnerService.start("mainSpinner");
                var request = {
                    statisticName : vm.statisticName, 
                    selectedVariantId : vm.selectedVariant.id,
                    variantDetails : []
                };

                _.forEach(vm.newVariantDetails, function(variantDetail){
                    request.variantDetails.push( 
                        {
                            variantDetailName : variantDetail.variantDetailName,
                            sortOrder : variantDetail.sortOrder
                        });
                });

                SupportApiService.addVariantDetails(request).then(function(response) {
                    console.log(response);
                    if(response.length > 0){
                        if(response.length !== request.variantDetails.length){
                            ToasterService.showSuccess('Variantdetaljer upplagda', $translate.instant('support.supportCase'), 15000);
                            var newArray = [];
                            
                            _.forEach(vm.newVariantDetails, function(variantDetail){
                                _.forEach(response, function(resp){
                                    if(variantDetail.variantDetailName === resp){
                                        newArray.push(variantDetail);
                                    }
                                }); 
                            });

                            vm.newVariantDetails = newArray;
                        }
                        
                        var message = '';
                        _.forEach(response, function(res){
                            message += '"' + res + '", ' + "\n";
                        });
                        message += 'finns redan!';
                        ToasterService.showError(message, $translate.instant('common.error'), 15000);
                    }
                    else{
                        cancelEditing();
                        ToasterService.showSuccess('Variantdetaljer upplagda', $translate.instant('support.supportCase'), 15000);
                    }
                }, function(error) {
                    var message = error.message + '\n';
                    _.forEach(error.errors, function(err) {
                        message += err.message + '\n';
                    });
                    ToasterService.showError(message, $translate.instant('common.error'));
                }).finally(function() {
                    loadSpinnerService.stop("mainSpinner");
                });
            }
        });
    }
    
    function cancelEditing() {
        vm.selectedVariant = undefined;
        vm.statisticName = 'UNKNOWN';
        vm.variantsToAdd = 1;
        vm.newVariantDetails = [];
        updateListOfVariants();
    }

    function isAllowedToSave() {
        var returnValue = true;
        
        _.forEach(vm.newVariantDetails, function(variantDetail){
            if(returnValue){
                returnValue = variantDetail.variantDetailName.length > 0;
            }
        })

        return returnValue && vm.statisticName.length > 0;
    }

    function updateListOfVariants(){
        if(vm.variantsToAdd < 1)
            vm.variantsToAdd = 1;
        else if(vm.variantsToAdd > 50)
                vm.variantsToAdd = 50;

        while(vm.newVariantDetails.length > vm.variantsToAdd){
            vm.newVariantDetails.splice(-1,1);
        }
        while(vm.newVariantDetails.length < vm.variantsToAdd){
            vm.newVariantDetails.push(angular.copy(vm.variantDetailTemplate));
        }

        doAutoSortOrder();
    }
    
    function doAutoSortOrder(){
        if(vm.autoSortOrder){
            _.forEach(vm.newVariantDetails, function(variantDetail){
                if(!variantDetail.overrideAutoSort)
                    variantDetail.sortOrder = asciiStringTranslate(variantDetail.variantDetailName);
            });
        }
    }

    function hasNumber(myString){
        return /\d/.test(myString);
    }

    function extractNumber(myString){
        const extracted = myString.replace(/[^\d.,]/g, '');
        return parseFloat(extracted.replace(',', '.'));
    }

    function asciiStringTranslate(theString){
        var cleanedString = theString.toLowerCase().replace(/[^a-z0-9,]+/g, '');
        var number = 0;

        if(!isNaN(cleanedString)){
            number = parseInt(cleanedString);
        }
        if(hasNumber(cleanedString) && !isNaN(extractNumber(cleanedString))){
            console.log(extractNumber(cleanedString));
            number = Math.round(extractNumber(cleanedString) * 100);
        }
        else{
            for(let i = 0; i < cleanedString.length; i++){
                if(isNaN(cleanedString.charAt(i)))
                    number += cleanedString.charCodeAt(i);
                else
                    number += parseInt(cleanedString.charAt(i));
            }

            if(!isNaN(cleanedString.charAt(0))){
                if(cleanedString.includes("s"))
                    number -= parseInt(cleanedString.charAt(0)) * 12;
                if(cleanedString.includes("l"))
                    number += parseInt(cleanedString.charAt(0)) * 82;
            }
        
            if(cleanedString.includes("s"))
                number += 5;
            if(cleanedString.includes("m"))
                number += 50
            if(cleanedString.includes("l"))
                number += 100
            
            if(cleanedString.includes("s"))
                number -= (cleanedString.match(/x/g) || []).length * 135;
            
            if(cleanedString.includes("l"))
                number += (cleanedString.match(/x/g) || []).length * 5;
                
        }

        return number;
    }
}

angular
    .module('supportcases.addvariantdetail', ['support.api'])
    .config(stateConfig)
    .controller('SupportCaseAddVariantDetailController', SupportCaseAddVariantDetailController);
